import script from "./TakoPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./TakoPanel.vue?vue&type=script&setup=true&lang=js"

import "./TakoPanel.vue?vue&type=style&index=0&id=7657327e&lang=scss&scoped=true"

import exportComponent from "H:\\project\\tako\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7657327e"]])

export default __exports__